import React from 'react';
import './Industries.css';

import { images, industries } from '../../../constants';
import { Heading } from '../../../components';



const Industries = () => {

  return (
    <section className="industries">

      {/* Section Heading */}
      <Heading title={industries.heading} subTitle={industries.sub} linear />

      {/* Main Description */}
      <p>{industries.content}</p>

      {/* Key Industries */}
      <div className="box-container">

        {/* Industries Points - Left Side */}
        <ul className="key-industries one">
          {industries.points.slice(0, 3).map((point) => (
            <div className='industry-item' key={point.id}>
              <div className='icon'>{point.icon}</div> {/* Point Icon */}
              <div className="text">
                <h3>{point.title}</h3> {/* Point Title */}
                <p>{point.content}</p> {/* Point Description */}
              </div>
            </div>
          ))}
        </ul>

        {/* Industries Image */}
        <div className="image">
          <img src={images.Industry} alt="Why Us" />
        </div>

        {/* Industries Points - Right Side */}
        <ul className="key-industries two">
          {industries.points.slice(3).map((point) => (
            <div className='industry-item' key={point.id}>
              <div className="text">
                <h3>{point.title}</h3> {/* Point Title */}
                <p>{point.content}</p> {/* Point Description */}
              </div>
              <div className='icon'>{point.icon}</div> {/* Point Icon */}
            </div>
          ))}
        </ul>

      </div>

    </section>
  );
};

export default Industries;